import { Experiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'

function useNewFlightUpsellExperiment(canShowFlightUpsell: boolean): boolean {
  const { isAnyVariant } = useExperiment(Experiments.croNewFlightUpsellTest, {
    canActivate: canShowFlightUpsell,
  })

  return isAnyVariant
}

export default useNewFlightUpsellExperiment
